<template><div><h1 id="aktionsauswertung-projekte" tabindex="-1"><a class="header-anchor" href="#aktionsauswertung-projekte"><span>Aktionsauswertung Projekte</span></a></h1>
<p>Aktionsauswertung Projekte — Aktionsauswertung nach Projekten und Projektgruppen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Auswertung listet alle Projekte in einem definierten Zeitraum auf. Zusätzlich können Einschränkungen wie bestimmte Projektgruppen oder nur aktive Projekte vorgenommen werden. Die Liste lässt sich nach Projektgruppen sortieren.</p>
<p>Pfad: <code v-pre>Projektfinanzierung → Auswertungen → Aktionsauswertung Projekte</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<dl>
<dt>Periode von/bis</dt>
<dd>Berücksichtigt nur Aktionen mit Eintrag der Projektperiode innerhalb dieses Bereiches.</dd>
<dt>(Aktions-)Datum von/bis</dt>
<dd>Berücksichtigt nur Aktionen mit Aktionsdatum innerhalb dieses Datumbereiches.</dd>
<dt>bis</dt>
<dd>Zeitraum bis Jahr</dd>
<dt>nur aktive Projekte</dt>
<dd>Es werden nur aktive Projekte berücksichtigt</dd>
<dt>Gruppierung</dt>
<dd>Keine oder nach Projektgruppen</dd>
<dt>Projektgruppe</dt>
<dd>Einschränkung nach Projektgruppen, * = alle</dd>
<dt>Ausgabe</dt>
<dd>Standard (Drucker: A4-Landscape)</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Die Ausgabe beinhaltet die folgenden Spalten:</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Projekt</td>
<td>Projekt-ID</td>
</tr>
<tr>
<td>Bezeichnung</td>
<td>Projektbezeichnung</td>
</tr>
<tr>
<td>Gruppe</td>
<td>Projektgruppe</td>
</tr>
<tr>
<td>Periode</td>
<td></td>
</tr>
<tr>
<td>Ziel</td>
<td></td>
</tr>
<tr>
<td>AnzahlEingereicht</td>
<td>Summe aller Aktionen mit Flag &quot;Eingabe&quot;</td>
</tr>
<tr>
<td>eingereicht</td>
<td></td>
</tr>
<tr>
<td>bewilligt</td>
<td></td>
</tr>
<tr>
<td>abgelehnt</td>
<td>abgesagt</td>
</tr>
<tr>
<td>überwiesen</td>
<td>bezahlt</td>
</tr>
<tr>
<td>Fehlbetrag</td>
<td></td>
</tr>
<tr>
<td>Prognose</td>
<td></td>
</tr>
</tbody>
</table>
<p>Em Ende der Auswertung werden noch die Summen pro Prjektgruppe und das Gesamttotal ausgegeben.</p>
</div></template>


